import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { closeMapContent as closeMapContentReducer } from '../store/slices/uiSlice';
import { useCurrentPath } from '../hooks/router';
import { parentUrlByUrl } from '../../../utils/paths';
const Title = ({ title, viewInMap }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const currentPath = useCurrentPath();
    const closeMapContent = () => {
        dispatch(closeMapContentReducer());
        window.dataLayer.push({
            event: 'storeLocatorViewStoresOnMapClick',
        });
    };
    const goBack = () => {
        if (location.key !== 'default') {
            navigate(-1);
        }
        else {
            navigate(parentUrlByUrl(currentPath), { replace: true });
        }
    };
    return (_jsxs("div", { className: "mb-4", children: [_jsx("button", { type: "button", className: "link-arrowed-left mb-2", onClick: goBack, children: t('store_locator.back') }), _jsx("h1", { className: "mb-0 font-size-extra-large", children: title }), viewInMap ? (_jsx("button", { className: "d-md-none link-arrowed-left mt-2", type: "button", onClick: closeMapContent, children: t('store_locator.view_in_map') })) : null] }));
};
export default Title;
